import { render, staticRenderFns } from "./SelectionManager.vue?vue&type=template&id=2aecde52&scoped=true"
import script from "./SelectionManager.vue?vue&type=script&lang=ts"
export * from "./SelectionManager.vue?vue&type=script&lang=ts"
import style0 from "./SelectionManager.vue?vue&type=style&index=0&id=2aecde52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aecde52",
  null
  
)

export default component.exports